import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import Time from "../components/time";
import { useParams, Link } from "react-router-dom";
import Swal from "sweetalert2";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";


const StnInward = () => {
   useAuthRedirect();
  const { stnNo} = useParams();
  const branch = localStorage.getItem("branch");

  const [header, setHeader] = useState({});
  const [data, setData] = useState([]);

  const canView  = hasPermission("STN Outward", "view");
  useEffect(() => {
  const fetchDataWithProgress = async () => {
    let progress = 0;
    let interval;

    // SweetAlert loading screen
    Swal.fire({
      title: "Loading STN Info",
      html: `
        <div id="progress-container" style="width: 100%; background: #e0e0e0; border-radius: 5px;">
          <div id="progress-bar" style="height: 10px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 5px;"></div>
        </div>
        <p id="progress-text" style="margin-top: 10px; font-size: 14px;">Loading... 0%</p>
      `,
      showConfirmButton: false,
      allowOutsideClick: false,
      didOpen: () => {
        const bar = document.getElementById("progress-bar");
        const text = document.getElementById("progress-text");

        interval = setInterval(() => {
          progress += 5;
          if (progress > 95) progress = 95; // Stop at 95%, finish at success
          if (bar) bar.style.width = `${progress}%`;
          if (text) text.innerText = `Loading... ${progress}%`;
        }, 100);
      },
    });

    try {
      const [headerRes, listRes] = await Promise.all([
        axios.get(`https://rfs2.infraconsoft.net.in/api/stnOutward_detailsHeader?stnNo=${stnNo}&branch=${branch}`),
        axios.get(`https://rfs2.infraconsoft.net.in/api/stnOutward_listData?stnNo=${stnNo}&branch=${branch}`)
      ]);

      // Process header details
      if (headerRes.data?.headerDetails?.length > 0) {
        const items = headerRes.data.headerDetails;
        const storeReqHeader = {
          headerNo: items[0].sfIssuesHeader_number,
          fromBranch: items[0].branchCode,
          transferBranch: items[0].sfIssuesHeader_branchcode,
          InwardDate: items[0].sfIssuesHeader_date,
          remarks: items[0].sfIssuesHeader_remarks,
          shift: items[0].sfissuesHeader_shiftNumber,
        };
        setHeader(storeReqHeader);
      }

      // Process list data
      setData(listRes.data.bottomDetails || []);

      // Finish progress
      progress = 100;
      document.getElementById("progress-bar").style.width = "100%";
      document.getElementById("progress-text").innerText = "Loading... 100%";

      // Close alert after small delay
      setTimeout(() => Swal.close(), 500);

    } catch (error) {
      console.error("Error fetching STN data:", error);
      Swal.fire({
        icon: "error",
        title: "Fetch Failed",
        text: "Failed to load STN header or list.",
      });
    } finally {
      clearInterval(interval);
    }
  };

  if (stnNo && branch) {
    {canView && (
    fetchDataWithProgress()
    )}
  }
}, [stnNo, branch]);


if (!canView) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
          <div className="back-div">
                    <h2 className="add-txt">STOCK TRANSFER NOTE - Outward VIew</h2>
                    <Link to='/inventory/stockTransferNoteView'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" >
            <div className="form-row">
              <div className="form-group">
                <label>Stock Issue No :</label>
                <input type="text" name="indentNo" value={header.headerNo} readOnly />
              </div>
              <div className="form-group">
                <label>Stock Transferred Date :</label>
                <input type="text"value={header.InwardDate ? new Date(header.InwardDate).toISOString().split("T")[0] : ""} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Stock Transfer From :</label>
                <input type="text" name="type" value={header.fromBranch} readOnly />
              </div>
              <div className="form-group">
                <label>Stock Transfer To :</label>
                <input type="text" name="branch" value={header.transferBranch} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" value={header.remarks} readOnly/>
              </div>

              <div className="form-group">
                <label>Shift :</label>
                <input type="text" value={header.shift} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>UOM</th>
                    <th>Quantity</th>
                    <th>Price</th>
                    <th>Value</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length > 0 ? (
                    <>
                      {data.map((item, index) => {
                        const value = item.sfIssuesDetail_price * item.sfissuesDetail_issuedQuantity;
                        return (
                          <tr key={index}>
                            <td>{index + 1}</td>
                            <td>{item.sfissuesDetail_itemCode}</td>
                            <td>{item.itemmaster_name}</td>
                            <td>{item.itemmaster_uom}</td>
                            <td>{item.sfissuesDetail_issuedQuantity}</td>
                            <td>{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(item.sfIssuesDetail_price || 0)}</td>
                            <td>{new Intl.NumberFormat("en-IN", {minimumFractionDigits: 2,maximumFractionDigits: 2,}).format(value || 0)}</td>
                
                          </tr>
                        );
                      })}
                      <tr>
                        <td colSpan={6}><strong>Total Value</strong></td>
                        <td>
<strong>
  {new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(
    data.reduce(
      (acc, item) =>
        acc +
        (Number(item.sfIssuesDetail_price) || 0) *
          (Number(item.sfissuesDetail_issuedQuantity) || 0),
      0
    )
  )}
</strong>

                        </td>
                     
                      </tr>
                    </>
                  ) : (
                    <tr>
                      <td colSpan="9">No items</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default StnInward;
